import React from "react";
import { animated, SpringConfig, useTrail } from "react-spring";
import { Title, TitleLink } from "./Header.style";

export const Animated = animated(Title);

export const title = [
  <>
    I am Mitra Mejía. <br /> Currently a Senior Software Engineer helping people
    build credit <TitleLink href="https://petalcard.com">@petal</TitleLink>
  </>,
];

const AnimatedTitle = () => {
  const config: SpringConfig = {
    mass: 3,
    tension: 80,
    friction: 40,
  };

  const trail = useTrail(title.length, {
    config,
    opacity: 1,
    from: { opacity: 0 },
  });

  return (
    <>
      {trail.map((style, index) => (
        <Animated key={index} style={style}>
          {title[index]}
        </Animated>
      ))}
    </>
  );
};

export default AnimatedTitle;
